module.exports = __webpack_public_path__ + "img/ic-visa_electron-white.998c0931.svg";